<div class="action-panel-container border-light radius-m">
    <div class="action-panel-box p-6">
        <div class="action-panel-header ">
            <span class="title content-m primary-text boldest-text">{{actionPanelMetadata.title}}</span>
            <div class="action-panel-header-right">
                <div class="acknowledge content-m px-2 radius-m white-text enable-action" *ngIf="isAcknowledgeClick" (click)="acknowledgeALert()">{{actionPanelMetadata.action_buttons.acknowledge}}</div>
                <div class="status content-m px-2 radius-m" [ngStyle]="alertvarservice.statusStyle[current_status]">{{actionPanelMetadata.status_info + ": " + current_status_obj.disp}}</div>
            </div>

        </div>
        <div class="action-panel-body" [formGroup]="action_panel" *ngIf="!find_terminal_state()">
            <div class="action-item-1">
                <p class="content-s boldest-text primary-text">{{actionPanelMetadata.action_headers.action}}</p>
                <div class="next-status-action" #nextStatus>
                    <app-overlay-select class="wb-tab px-2" overlaycontainer="border-none shadow-none" [placeHolder]="actionPanelMetadata.action_placeholders.action" [data]="sharedservice.getActionCurrentStaus(current_status)" formControlName="action" sort="true"></app-overlay-select>
                </div>
            </div>
            <div class="action-item-2" *ngIf="!isEmptyObject(current_action) && current_action.priority">
                <p class="content-s boldest-text primary-text">{{actionPanelMetadata.action_headers.priority}}</p>
                <div class="update-priority" #updatePriority>
                    <app-overlay-select class="wb-tab px-2" overlaycontainer="border-none shadow-none" [placeHolder]="actionPanelMetadata.action_placeholders.priority" [data]="sharedservice.priority_option" formControlName="priority" sort="true"></app-overlay-select>
                </div>
            </div>
            <div class="action-item-3" *ngIf="!isEmptyObject(current_action)  && current_action.reassign">
                <p class="content-s boldest-text primary-text">{{actionPanelMetadata.action_headers.reassign}}</p>
                <div class="reassign-analyst" #reassignAnalyst>
                    <app-overlay-select class="wb-tab px-2" overlaycontainer="border-none shadow-none" [placeHolder]="actionPanelMetadata.action_placeholders.reassign" [data]="sharedservice.analystlist" formControlName="reassign" sort="true"></app-overlay-select>
                </div>
            </div>
            <div class="action-item-4" *ngIf="!isEmptyObject(current_action)  && current_action.hasReason">
                <p class="content-s boldest-text primary-text">{{actionPanelMetadata.action_headers.comment}}</p>
                <div class="comment" #comment>
                    <app-overlay-select class="wb-tab px-2" overlaycontainer="border-none shadow-none" [placeHolder]="actionPanelMetadata.action_placeholders.comment" [data]="getReasons(current_action.value)" formControlName="reason" sort="true"></app-overlay-select>
                </div>
            </div>
        </div>
        <div class="action-panel-footer" *ngIf="!find_terminal_state()">
            <div class="cancel-btn content-m px-5 py-2 radius-s boldest-text enable-action" (click)="cancelAction()">
                <p class="p-0 m-0">{{actionPanelMetadata.action_buttons.cancel}}</p>
            </div>
            <div class="submit-btn content-m px-5 py-2 radius-s white-text boldest-text enable-action" [ngClass]="current_status == 0 ? 'not-allowed' : ''" (click)="saveAction()">
                <mat-icon>save</mat-icon>
                <p class="p-0 m-0">{{actionPanelMetadata.action_buttons.save}}</p>
            </div>
        </div>
        <div *ngIf="find_terminal_state()" class="action-panel-terminal border-light radius-m p-4">
            <mat-icon>lock</mat-icon>
            <p class="content-m m-0">{{actionPanelMetadata.action_headers.terminal1}} (<strong>{{current_status_obj.disp}}</strong>). {{actionPanelMetadata.action_headers.terminal2}}</p>
        </div>
    </div>

</div>